/**
 * aswbe search eapi（ShoppingShopping）
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { FareFamilyWithService } from './fareFamilyWithService';

/**
 * FareFamily情報リスト <br>
 * ※ASWDB(マスタ)におけるFFの表示順にソートして返却する
 */
export interface FareFamilies {
  /**
   * FareFamilyコード
   */
  fareFamilyCode?: string;

  /**
   * 変更条件タイプ <br>
   *   Priority Codeをキーに取得した、ASWDB(マスタ)の変更可否区分を返却する <br>
   *     * unavailable：予約変更不可 <br>
   *     * withPenalty：予約変更可能（手数料あり） <br>
   *     * free：予約変更可能（手数料なし）
   */
  changeConditionsType?: FareFamilies.ChangeConditionsTypeEnum;

  /**
   * 払戻条件タイプ <br>
   *    Priority Codeをキーに取得した、ASWDB(マスタ)の払戻可否区分を返却する <br>
   *      * unavailable：払戻不可 <br>
   *      * withPenalty：払戻可能（手数料あり）<br>
   *      * free：払戻可能（手数料なし）
   */
  refundConditionsType?: FareFamilies.RefundConditionsTypeEnum;

  /**
   * FareFamilyサービス情報
   */
  fareFamilyWithService?: FareFamilyWithService;

  /**
   * 無料預け入れ手荷物個数 <br>
   *   travelSolutions内に含まれるセグメントに対する最小の値を回答する <br>
   *   ※ただし、DxAPIより全セグメントに対する手荷物情報に対して、重量のみで回答された場合には返却せず、個数と重量が混在した回答の場合には、個数のみを考慮して回答する <br>
   *   ※DxAPIより個数情報が返却された場合のみ返却する
   */
  minFreeCheckedBaggageQuantity?: number;
}

export namespace FareFamilies {
  export type ChangeConditionsTypeEnum = 'unavailable' | 'withPenalty' | 'free';
  export const ChangeConditionsTypeEnum = {
    Unavailable: 'unavailable' as ChangeConditionsTypeEnum,
    WithPenalty: 'withPenalty' as ChangeConditionsTypeEnum,
    Free: 'free' as ChangeConditionsTypeEnum,
  };
  export type RefundConditionsTypeEnum = 'unavailable' | 'withPenalty' | 'free';
  export const RefundConditionsTypeEnum = {
    Unavailable: 'unavailable' as RefundConditionsTypeEnum,
    WithPenalty: 'withPenalty' as RefundConditionsTypeEnum,
    Free: 'free' as RefundConditionsTypeEnum,
  };
}
